import { DepotsConfiguration } from "./components/DepotsConfiguration";

export default DepotsConfiguration;